import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import './Components/SharedFiles/CommonFile/Style.css';
import '../src/Components/SharedFiles/CommonFile/Style.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Provider } from 'react-redux';
import store from './Components/APIServices/store';
import 'primeicons/primeicons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

